import React from "react";

const HiFive = () => {
  return (
    <div>
      <svg
        width={22}
        height={22}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.26 4.307c.913 2.013 2.033 4.482 2.873 5.463.165-.381.147-1.02.335-2.58.17-1.407 1.33-1.542 1.829-1.442 1.102.23 1.438 1.347 1.4 1.759-.058.656-.06.634-.18 2.221-.177 2.322.72 4.075.802 6.062 0 3.745-3.283 5.586-5.58 5.586-1.838 0-3.678-1.176-4.367-1.764l-3.447-3.148c-.422-.328-1.465-1.411-1.923-2.034-1.248-1.698.557-2.867 1.57-2.573-.079-.061-.56-.843-.79-1.225-.62-1.243 0-2.07.457-2.299 1.037-.516 1.8.065 2.04.381-.092-.156-.38-.787-.844-1.946-.465-1.158.283-1.873.715-2.086.938-.435 1.829.117 2.051.61.11.24.698 1.53.954 2.097-.193-.47-.543-1.408-.666-1.84-.246-1.02.345-1.72.721-1.9.521-.249 1.61-.314 2.04.634l.01.024z"
          fill="url(#paint0_radial_61092_177672)"
        />
        <path
          d="M14.26 4.307c.914 2.013 2.033 4.482 2.873 5.463.165-.381.147-1.02.335-2.58.17-1.407 1.33-1.542 1.83-1.442 1.102.23 1.437 1.347 1.4 1.759-.058.656-.061.634-.181 2.221-.177 2.322.72 4.075.802 6.062 0 3.745-3.283 5.586-5.58 5.586-1.838 0-3.678-1.176-4.367-1.764l-3.447-3.148c-.422-.328-1.465-1.411-1.923-2.034-1.247-1.698.557-2.867 1.571-2.573-.08-.061-.56-.843-.791-1.225-.619-1.243 0-2.07.457-2.299 1.038-.516 1.8.065 2.04.381-.092-.156-.38-.787-.844-1.946-.464-1.158.283-1.873.715-2.086.938-.435 1.829.117 2.052.61l.954 2.097c-.194-.47-.543-1.408-.667-1.84-.246-1.02.346-1.72.72-1.9.523-.249 1.61-.314 2.04.634l.012.024z"
          fill="url(#paint1_radial_61092_177672)"
        />
        <path
          d="M20.697 7.507c-.059.656-.062.634-.182 2.222-.062.82.384 3.84.384 3.84-1.084.354-3.432-.114-3.766-3.8.164-.38.146-1.02.334-2.58.17-1.406 1.33-1.54 1.829-1.44 1.102.23 1.438 1.346 1.4 1.758z"
          fill="url(#paint2_radial_61092_177672)"
        />
        <path
          d="M20.697 7.507c-.059.656-.062.634-.182 2.222-.062.82.384 3.84.384 3.84-1.084.354-3.432-.114-3.766-3.8.164-.38.146-1.02.334-2.58.17-1.406 1.33-1.54 1.829-1.44 1.102.23 1.438 1.346 1.4 1.758z"
          fill="url(#paint3_radial_61092_177672)"
        />
        <path
          d="M20.697 7.507c-.059.656-.062.634-.182 2.222-.062.82.384 3.84.384 3.84-1.084.354-3.432-.114-3.766-3.8.164-.38.146-1.02.334-2.58.17-1.406 1.33-1.54 1.829-1.44 1.102.23 1.438 1.346 1.4 1.758z"
          fill="url(#paint4_radial_61092_177672)"
        />
        <path
          d="M14.26 4.307c.912 2.013 2.032 4.482 2.872 5.463-.131 1.122-1.134 1.659-1.998 1.458-1.09-.317-1.504-1.09-1.504-1.09s-.285-.441-.562-.926c-.321-.561-.262-.549-.8-1.564-.106-.2-.623-1.553-.78-2.1-.246-1.02.346-1.718.721-1.898.521-.25 1.61-.315 2.04.633l.01.024z"
          fill="url(#paint5_radial_61092_177672)"
        />
        <path
          d="M14.26 4.307c.912 2.013 2.032 4.482 2.872 5.463-.131 1.122-1.134 1.659-1.998 1.458-1.09-.317-1.504-1.09-1.504-1.09s-.285-.441-.562-.926c-.321-.561-.262-.549-.8-1.564-.106-.2-.623-1.553-.78-2.1-.246-1.02.346-1.718.721-1.898.521-.25 1.61-.315 2.04.633l.01.024z"
          fill="url(#paint6_linear_61092_177672)"
        />
        <path
          d="M14.26 4.307c.912 2.013 2.032 4.482 2.872 5.463-.131 1.122-1.134 1.659-1.998 1.458-1.09-.317-1.504-1.09-1.504-1.09s-.285-.441-.562-.926c-.321-.561-.262-.549-.8-1.564-.106-.2-.623-1.553-.78-2.1-.246-1.02.346-1.718.721-1.898.521-.25 1.61-.315 2.04.633l.01.024z"
          fill="url(#paint7_radial_61092_177672)"
        />
        <path
          d="M14.26 4.307c.912 2.013 2.032 4.482 2.872 5.463-.131 1.122-1.134 1.659-1.998 1.458-1.09-.317-1.504-1.09-1.504-1.09s-.285-.441-.562-.926c-.321-.561-.262-.549-.8-1.564-.106-.2-.623-1.553-.78-2.1-.246-1.02.346-1.718.721-1.898.521-.25 1.61-.315 2.04.633l.01.024z"
          fill="url(#paint8_radial_61092_177672)"
        />
        <path
          d="M14.26 4.307c.912 2.013 2.032 4.482 2.872 5.463-.131 1.122-1.134 1.659-1.998 1.458-1.09-.317-1.504-1.09-1.504-1.09s-.285-.441-.562-.926c-.321-.561-.262-.549-.8-1.564-.106-.2-.623-1.553-.78-2.1-.246-1.02.346-1.718.721-1.898.521-.25 1.61-.315 2.04.633l.01.024z"
          fill="url(#paint9_linear_61092_177672)"
        />
        <path
          d="M11.198 5.29c.147.324 1.16 2.544 1.067 2.357.272.615 1.117 2.115 1.363 2.525.543.905-.07 1.657-.465 1.886-1.138.66-1.791-.181-1.791-.181-.6-.879-1.101-1.611-2.092-3.17a20.65 20.65 0 01-.85-1.94c-.432-1.201.284-1.873.716-2.086.938-.435 1.829.117 2.052.61z"
          fill="url(#paint10_radial_61092_177672)"
        />
        <path
          d="M11.198 5.29c.147.324 1.16 2.544 1.067 2.357.272.615 1.117 2.115 1.363 2.525.543.905-.07 1.657-.465 1.886-1.138.66-1.791-.181-1.791-.181-.6-.879-1.101-1.611-2.092-3.17a20.65 20.65 0 01-.85-1.94c-.432-1.201.284-1.873.716-2.086.938-.435 1.829.117 2.052.61z"
          fill="url(#paint11_linear_61092_177672)"
        />
        <path
          d="M11.198 5.29c.147.324 1.16 2.544 1.067 2.357.272.615 1.117 2.115 1.363 2.525.543.905-.07 1.657-.465 1.886-1.138.66-1.791-.181-1.791-.181-.6-.879-1.101-1.611-2.092-3.17a20.65 20.65 0 01-.85-1.94c-.432-1.201.284-1.873.716-2.086.938-.435 1.829.117 2.052.61z"
          fill="url(#paint12_radial_61092_177672)"
        />
        <path
          d="M11.198 5.29c.147.324 1.16 2.544 1.067 2.357.272.615 1.117 2.115 1.363 2.525.543.905-.07 1.657-.465 1.886-1.138.66-1.791-.181-1.791-.181-.6-.879-1.101-1.611-2.092-3.17a20.65 20.65 0 01-.85-1.94c-.432-1.201.284-1.873.716-2.086.938-.435 1.829.117 2.052.61z"
          fill="url(#paint13_radial_61092_177672)"
        />
        <path
          d="M11.198 5.29c.147.324 1.16 2.544 1.067 2.357.272.615 1.117 2.115 1.363 2.525.543.905-.07 1.657-.465 1.886-1.138.66-1.791-.181-1.791-.181-.6-.879-1.101-1.611-2.092-3.17a20.65 20.65 0 01-.85-1.94c-.432-1.201.284-1.873.716-2.086.938-.435 1.829.117 2.052.61z"
          fill="url(#paint14_radial_61092_177672)"
        />
        <path
          d="M11.198 5.29c.147.324 1.16 2.544 1.067 2.357.272.615 1.117 2.115 1.363 2.525.543.905-.07 1.657-.465 1.886-1.138.66-1.791-.181-1.791-.181-.6-.879-1.101-1.611-2.092-3.17a20.65 20.65 0 01-.85-1.94c-.432-1.201.284-1.873.716-2.086.938-.435 1.829.117 2.052.61z"
          fill="url(#paint15_linear_61092_177672)"
        />
        <path
          d="M7.241 8.332c1.038-.516 1.8.065 2.04.381.75 1.13 1.643 2.415 2.055 3.1 1.103 1.822-1.153 2.612-1.153 2.612-2.075-2.337-2.459-2.455-2.608-2.57-.08-.06-.56-.842-.791-1.225-.619-1.242 0-2.07.457-2.298z"
          fill="url(#paint16_radial_61092_177672)"
        />
        <path
          d="M7.241 8.332c1.038-.516 1.8.065 2.04.381.75 1.13 1.643 2.415 2.055 3.1 1.103 1.822-1.153 2.612-1.153 2.612-2.075-2.337-2.459-2.455-2.608-2.57-.08-.06-.56-.842-.791-1.225-.619-1.242 0-2.07.457-2.298z"
          fill="url(#paint17_linear_61092_177672)"
        />
        <path
          d="M7.241 8.332c1.038-.516 1.8.065 2.04.381.75 1.13 1.643 2.415 2.055 3.1 1.103 1.822-1.153 2.612-1.153 2.612-2.075-2.337-2.459-2.455-2.608-2.57-.08-.06-.56-.842-.791-1.225-.619-1.242 0-2.07.457-2.298z"
          fill="url(#paint18_radial_61092_177672)"
        />
        <path
          d="M7.241 8.332c1.038-.516 1.8.065 2.04.381.75 1.13 1.643 2.415 2.055 3.1 1.103 1.822-1.153 2.612-1.153 2.612-2.075-2.337-2.459-2.455-2.608-2.57-.08-.06-.56-.842-.791-1.225-.619-1.242 0-2.07.457-2.298z"
          fill="url(#paint19_radial_61092_177672)"
        />
        <path
          d="M7.241 8.332c1.038-.516 1.8.065 2.04.381.75 1.13 1.643 2.415 2.055 3.1 1.103 1.822-1.153 2.612-1.153 2.612-2.075-2.337-2.459-2.455-2.608-2.57-.08-.06-.56-.842-.791-1.225-.619-1.242 0-2.07.457-2.298z"
          fill="url(#paint20_radial_61092_177672)"
        />
        <path
          d="M7.241 8.332c1.038-.516 1.8.065 2.04.381.75 1.13 1.643 2.415 2.055 3.1 1.103 1.822-1.153 2.612-1.153 2.612-2.075-2.337-2.459-2.455-2.608-2.57-.08-.06-.56-.842-.791-1.225-.619-1.242 0-2.07.457-2.298z"
          fill="url(#paint21_radial_61092_177672)"
        />
        <path
          d="M6.002 14.428c-1.247-1.697.557-2.866 1.571-2.572.48.296 1.223 1.04 1.538 1.375 2.012 1.96 1.677 2.566 1.114 3.232-.545.452-1.254.814-2.3 0-.422-.328-1.465-1.411-1.923-2.035z"
          fill="url(#paint22_radial_61092_177672)"
        />
        <path
          d="M6.002 14.428c-1.247-1.697.557-2.866 1.571-2.572.48.296 1.223 1.04 1.538 1.375 2.012 1.96 1.677 2.566 1.114 3.232-.545.452-1.254.814-2.3 0-.422-.328-1.465-1.411-1.923-2.035z"
          fill="url(#paint23_radial_61092_177672)"
        />
        <path
          d="M6.002 14.428c-1.247-1.697.557-2.866 1.571-2.572.48.296 1.223 1.04 1.538 1.375 2.012 1.96 1.677 2.566 1.114 3.232-.545.452-1.254.814-2.3 0-.422-.328-1.465-1.411-1.923-2.035z"
          fill="url(#paint24_radial_61092_177672)"
        />
        <path
          d="M6.002 14.428c-1.247-1.697.557-2.866 1.571-2.572.48.296 1.223 1.04 1.538 1.375 2.012 1.96 1.677 2.566 1.114 3.232-.545.452-1.254.814-2.3 0-.422-.328-1.465-1.411-1.923-2.035z"
          fill="url(#paint25_radial_61092_177672)"
        />
        <path
          d="M6.002 14.428c-1.247-1.697.557-2.866 1.571-2.572.48.296 1.223 1.04 1.538 1.375 2.012 1.96 1.677 2.566 1.114 3.232-.545.452-1.254.814-2.3 0-.422-.328-1.465-1.411-1.923-2.035z"
          fill="url(#paint26_linear_61092_177672)"
        />
        <path
          d="M14.26 4.307c.914 2.013 2.033 4.482 2.873 5.463.165-.381.147-1.02.335-2.58.17-1.407 1.33-1.542 1.83-1.442 1.102.23 1.437 1.347 1.4 1.759-.058.656-.061.634-.181 2.221-.177 2.322.72 4.075.802 6.062 0 3.745-3.283 5.586-5.58 5.586-1.838 0-3.678-1.176-4.367-1.764l-3.447-3.148c-.422-.328-1.465-1.411-1.923-2.034-1.247-1.698.557-2.867 1.571-2.573-.08-.061-.56-.843-.791-1.225-.619-1.243 0-2.07.457-2.299 1.038-.516 1.8.065 2.04.381-.092-.156-.38-.787-.844-1.946-.464-1.158.283-1.873.715-2.086.938-.435 1.829.117 2.052.61l.954 2.097c-.194-.47-.543-1.408-.667-1.84-.246-1.02.346-1.72.72-1.9.523-.249 1.61-.314 2.04.634l.012.024z"
          fill="url(#paint27_radial_61092_177672)"
        />
        <path
          d="M14.26 4.307c.914 2.013 2.033 4.482 2.873 5.463.165-.381.147-1.02.335-2.58.17-1.407 1.33-1.542 1.83-1.442 1.102.23 1.437 1.347 1.4 1.759-.058.656-.061.634-.181 2.221-.177 2.322.72 4.075.802 6.062 0 3.745-3.283 5.586-5.58 5.586-1.838 0-3.678-1.176-4.367-1.764l-3.447-3.148c-.422-.328-1.465-1.411-1.923-2.034-1.247-1.698.557-2.867 1.571-2.573-.08-.061-.56-.843-.791-1.225-.619-1.243 0-2.07.457-2.299 1.038-.516 1.8.065 2.04.381-.092-.156-.38-.787-.844-1.946-.464-1.158.283-1.873.715-2.086.938-.435 1.829.117 2.052.61l.954 2.097c-.194-.47-.543-1.408-.667-1.84-.246-1.02.346-1.72.72-1.9.523-.249 1.61-.314 2.04.634l.012.024z"
          fill="url(#paint28_radial_61092_177672)"
        />
        <path
          d="M14.26 4.307c.914 2.013 2.033 4.482 2.873 5.463.165-.381.147-1.02.335-2.58.17-1.407 1.33-1.542 1.83-1.442 1.102.23 1.437 1.347 1.4 1.759-.058.656-.061.634-.181 2.221-.177 2.322.72 4.075.802 6.062 0 3.745-3.283 5.586-5.58 5.586-1.838 0-3.678-1.176-4.367-1.764l-3.447-3.148c-.422-.328-1.465-1.411-1.923-2.034-1.247-1.698.557-2.867 1.571-2.573-.08-.061-.56-.843-.791-1.225-.619-1.243 0-2.07.457-2.299 1.038-.516 1.8.065 2.04.381-.092-.156-.38-.787-.844-1.946-.464-1.158.283-1.873.715-2.086.938-.435 1.829.117 2.052.61l.954 2.097c-.194-.47-.543-1.408-.667-1.84-.246-1.02.346-1.72.72-1.9.523-.249 1.61-.314 2.04.634l.012.024z"
          fill="url(#paint29_radial_61092_177672)"
        />
        <path
          d="M15.534 7c.563 1.15 1.125 2.182 1.6 2.746.05.503.093.79.213 1.223-.949-.95-1.868-3.025-1.814-3.969z"
          fill="url(#paint30_radial_61092_177672)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.092 11.674a.405.405 0 01.404.405c0 .675.273 1.579.862 2.308.577.718 1.455 1.261 2.685 1.261a.404.404 0 010 .809c-1.502 0-2.6-.675-3.315-1.562-.704-.873-1.04-1.957-1.04-2.817a.405.405 0 01.404-.404z"
          fill="url(#paint31_radial_61092_177672)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.092 11.674a.405.405 0 01.404.405c0 .675.273 1.579.862 2.308.577.718 1.455 1.261 2.685 1.261a.404.404 0 010 .809c-1.502 0-2.6-.675-3.315-1.562-.704-.873-1.04-1.957-1.04-2.817a.405.405 0 01.404-.404z"
          fill="url(#paint32_radial_61092_177672)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.092 11.674a.405.405 0 01.404.405c0 .675.273 1.579.862 2.308.577.718 1.455 1.261 2.685 1.261a.404.404 0 010 .809c-1.502 0-2.6-.675-3.315-1.562-.704-.873-1.04-1.957-1.04-2.817a.405.405 0 01.404-.404z"
          fill="url(#paint33_radial_61092_177672)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.834 13.117a.405.405 0 01.405.405c0 1.433 1.072 3.347 3.327 3.347a.404.404 0 010 .808C1.73 17.677.43 15.255.43 13.522a.405.405 0 01.404-.405z"
          fill="url(#paint34_radial_61092_177672)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M.834 13.117a.405.405 0 01.405.405c0 1.433 1.072 3.347 3.327 3.347a.404.404 0 010 .808C1.73 17.677.43 15.255.43 13.522a.405.405 0 01.404-.405z"
          fill="url(#paint35_radial_61092_177672)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.977 6.388a.405.405 0 01-.407-.402c-.004-.675-.283-1.577-.876-2.303C14.11 2.969 13.23 2.432 12 2.439a.405.405 0 01-.005-.808c1.502-.01 2.605.66 3.325 1.54.71.869 1.053 1.95 1.059 2.81a.405.405 0 01-.402.407z"
          fill="url(#paint36_radial_61092_177672)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.977 6.388a.405.405 0 01-.407-.402c-.004-.675-.283-1.577-.876-2.303C14.11 2.969 13.23 2.432 12 2.439a.405.405 0 01-.005-.808c1.502-.01 2.605.66 3.325 1.54.71.869 1.053 1.95 1.059 2.81a.405.405 0 01-.402.407z"
          fill="url(#paint37_radial_61092_177672)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.225 4.938a.405.405 0 01-.406-.402c-.01-1.432-1.095-3.34-3.35-3.325a.404.404 0 01-.005-.809C16.3.384 17.615 2.8 17.627 4.532a.405.405 0 01-.402.406z"
          fill="url(#paint38_radial_61092_177672)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.225 4.938a.405.405 0 01-.406-.402c-.01-1.432-1.095-3.34-3.35-3.325a.404.404 0 01-.005-.809C16.3.384 17.615 2.8 17.627 4.532a.405.405 0 01-.402.406z"
          fill="url(#paint39_radial_61092_177672)"
        />
        <g filter="url(#filter0_f_61092_177672)">
          <path
            d="M15.893 9.82c-1.452.586-4.74 2.51-5.706 6.798"
            stroke="#FFC339"
            strokeLinecap="round"
          />
        </g>
        <defs>
          <filter
            id="filter0_f_61092_177672"
            x={8.6875}
            y={8.32031}
            width={8.70312}
            height={9.79883}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feBlend
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation={0.5}
              result="effect1_foregroundBlur_61092_177672"
            />
          </filter>
          <radialGradient
            id="paint0_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(60.101 -1.38 16.311) scale(15.789 10.3147)"
          >
            <stop offset={0.003} stopColor="#FFC133" />
            <stop offset={0.698} stopColor="#FFC53F" />
            <stop offset={0.797} stopColor="#FFAD3E" />
            <stop offset={0.945} stopColor="#EC7D58" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(-93.012 16.753 -3.691) scale(9.36758 3.58868)"
          >
            <stop offset={0.003} stopColor="#FFE849" />
            <stop offset={1} stopColor="#FFE647" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint2_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-.84372 4.94531 -1.89453 -.32323 20.193 6.141)"
          >
            <stop offset={0.003} stopColor="#FFE849" />
            <stop offset={1} stopColor="#FFE647" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint3_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.0291 0 0 8.22878 17.132 9.162)"
          >
            <stop stopColor="#EE9F2C" />
            <stop offset={1} stopColor="#EE9F2C" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint4_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-.24333 -3.4066 2.36615 -.16901 18.023 12.353)"
          >
            <stop stopColor="#FFC93D" />
            <stop offset={1} stopColor="#FFC33A" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint5_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-3.14062 1.73916 -3.49363 -6.3089 16.115 7.168)"
          >
            <stop offset={0.563} stopColor="#F09D2E" stopOpacity={0} />
            <stop offset={1} stopColor="#F09D2E" />
          </radialGradient>
          <linearGradient
            id="paint6_linear_61092_177672"
            x1={14.2815}
            y1={10.846}
            x2={14.2815}
            y2={8.9072}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFC337" />
            <stop offset={1} stopColor="#FFC337" stopOpacity={0} />
          </linearGradient>
          <radialGradient
            id="paint7_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.34376 -.5625 1.2439 5.1829 15.365 4.313)"
          >
            <stop stopColor="#FFEC4C" />
            <stop offset={1} stopColor="#FFEC4C" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint8_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(33.306 -.119 20.85) scale(2.35308 1.82437)"
          >
            <stop stopColor="#D99F2B" />
            <stop offset={1} stopColor="#D99F2B" stopOpacity={0} />
          </radialGradient>
          <linearGradient
            id="paint9_linear_61092_177672"
            x1={11.8028}
            y1={8.2277}
            x2={12.9743}
            y2={7.6652}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A85300" />
            <stop offset={0.825} stopColor="#A85300" stopOpacity={0} />
          </linearGradient>
          <radialGradient
            id="paint10_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(149.148 5.223 5.894) scale(3.46061 7.22162)"
          >
            <stop offset={0.563} stopColor="#F09D2E" stopOpacity={0} />
            <stop offset={1} stopColor="#F09D2E" />
          </radialGradient>
          <linearGradient
            id="paint11_linear_61092_177672"
            x1={10.9944}
            y1={12.03}
            x2={10.9944}
            y2={10.0515}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFC337" />
            <stop offset={1} stopColor="#FFC337" stopOpacity={0} />
          </linearGradient>
          <radialGradient
            id="paint12_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.90637 -1.28069 3.89905 5.80395 12.33 6.07)"
          >
            <stop stopColor="#FFEC4C" />
            <stop offset={1} stopColor="#FFEC4C" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint13_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.625 -1.21875 5.56495 11.98603 10.581 8.906)"
          >
            <stop offset={0.598} stopColor="#F09D2E" stopOpacity={0} />
            <stop offset={1} stopColor="#F09D2E" />
          </radialGradient>
          <radialGradient
            id="paint14_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(32.601 -3.756 15.865) scale(2.39259 1.90693)"
          >
            <stop stopColor="#D99F2B" />
            <stop offset={1} stopColor="#D99F2B" stopOpacity={0} />
          </radialGradient>
          <linearGradient
            id="paint15_linear_61092_177672"
            x1={9.01068}
            y1={9.37495}
            x2={9.79068}
            y2={8.8297}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A85300" />
            <stop offset={0.825} stopColor="#A85300" stopOpacity={0} />
          </linearGradient>
          <radialGradient
            id="paint16_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(137.351 3.162 7.732) scale(2.86693 5.61401)"
          >
            <stop offset={0.563} stopColor="#F09D2E" stopOpacity={0} />
            <stop offset={1} stopColor="#F09D2E" />
          </radialGradient>
          <linearGradient
            id="paint17_linear_61092_177672"
            x1={9.08196}
            y1={14.4254}
            x2={9.08196}
            y2={12.7657}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFC337" />
            <stop offset={1} stopColor="#FFC337" stopOpacity={0} />
          </linearGradient>
          <radialGradient
            id="paint18_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.13342 -.465 .985 4.51917 10.024 8.816)"
          >
            <stop stopColor="#FFEC4C" />
            <stop offset={1} stopColor="#FFEC4C" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint19_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.31922 -1.96107 10.02567 11.85664 8.69 11.805)"
          >
            <stop offset={0.598} stopColor="#F09D2E" stopOpacity={0} />
            <stop offset={1} stopColor="#F09D2E" />
          </radialGradient>
          <radialGradient
            id="paint20_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.91166 1.08172 -.81413 1.43877 6.2 8.127)"
          >
            <stop stopColor="#D99F2B" />
            <stop offset={1} stopColor="#D99F2B" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint21_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(-45.764 18.42 -2.488) scale(1.24307 5.61261)"
          >
            <stop stopColor="#A85300" />
            <stop offset={0.825} stopColor="#A85300" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint22_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-2.26185 1.6817 -3.1642 -4.25579 10.087 14.537)"
          >
            <stop offset={0.563} stopColor="#F09D2E" stopOpacity={0} />
            <stop offset={1} stopColor="#F09D2E" />
          </radialGradient>
          <radialGradient
            id="paint23_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.2884 -.40258 .69939 3.9755 9.333 12.406)"
          >
            <stop stopColor="#FFEC4C" />
            <stop offset={1} stopColor="#FFEC4C" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint24_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(-34.314 28.235 -5.3) scale(3.01187 14.5411)"
          >
            <stop offset={0.598} stopColor="#F09D2E" stopOpacity={0} />
            <stop offset={1} stopColor="#F09D2E" />
          </radialGradient>
          <radialGradient
            id="paint25_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.05053 .93655 -.62147 1.36068 5.23 11.81)"
          >
            <stop stopColor="#D99F2B" />
            <stop offset={1} stopColor="#D99F2B" stopOpacity={0} />
          </radialGradient>
          <linearGradient
            id="paint26_linear_61092_177672"
            x1={10.2102}
            y1={19.6873}
            x2={8.32242}
            y2={15.8263}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFC337" />
            <stop offset={1} stopColor="#FFC337" stopOpacity={0} />
          </linearGradient>
          <radialGradient
            id="paint27_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-8.20315 10.12498 -16.37433 -13.2663 16.96 8.392)"
          >
            <stop offset={0.872} stopColor="#F6814F" stopOpacity={0} />
            <stop offset={1} stopColor="#F7814F" />
          </radialGradient>
          <radialGradient
            id="paint28_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(76.293 1.689 13.332) scale(13.8475 15.1937)"
          >
            <stop offset={0.853} stopColor="#F6814F" stopOpacity={0} />
            <stop offset={1} stopColor="#F7814F" />
          </radialGradient>
          <radialGradient
            id="paint29_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(64.44 4.71 16.299) scale(2.39017 2.1308)"
          >
            <stop stopColor="#D99F2B" />
            <stop offset={1} stopColor="#D99F2B" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint30_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-.78226 .46532 -1.4399 -2.42063 17.348 9.586)"
          >
            <stop offset={0.201} stopColor="#B4813D" />
            <stop offset={1} stopColor="#B4813D" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint31_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(1.86608 3.5201 -5.22045 2.76747 2.667 11.891)"
          >
            <stop stopColor="#419FFD" />
            <stop offset={1} stopColor="#4B6DCB" />
          </radialGradient>
          <radialGradient
            id="paint32_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(.5625 .02344 -.04932 1.18378 1.54 12.188)"
          >
            <stop stopColor="#5486C7" />
            <stop offset={1} stopColor="#5486C7" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint33_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(111.801 -2.333 9.649) scale(.56797 1.6706)"
          >
            <stop stopColor="#5486C7" />
            <stop offset={1} stopColor="#5486C7" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint34_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(-.25887 3.14062 -5.28065 -.43526 2.96 13.97)"
          >
            <stop stopColor="#419FFD" />
            <stop offset={1} stopColor="#4B6DCB" />
          </radialGradient>
          <radialGradient
            id="paint35_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(.53656 .02235 -.04701 1.12866 .29 13.607)"
          >
            <stop stopColor="#5486C7" />
            <stop offset={1} stopColor="#5486C7" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint36_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="rotate(60.196 5.786 11.49) scale(3.34739 4.96433)"
          >
            <stop stopColor="#419FFD" />
            <stop offset={1} stopColor="#4B6DCB" />
          </radialGradient>
          <radialGradient
            id="paint37_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(.45572 .15568 -.25058 .73351 11.502 1.97)"
          >
            <stop stopColor="#4D8AC1" />
            <stop offset={1} stopColor="#4D8AC1" stopOpacity={0} />
          </radialGradient>
          <radialGradient
            id="paint38_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(2.03571 3.62611 -5.37909 3.01984 14.29 -.43)"
          >
            <stop stopColor="#419FFD" />
            <stop offset={1} stopColor="#4B6DCB" />
          </radialGradient>
          <radialGradient
            id="paint39_radial_61092_177672"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(.4347 .14844 -.23882 .69942 12.976 .727)"
          >
            <stop stopColor="#4D8AC1" />
            <stop offset={1} stopColor="#4D8AC1" stopOpacity={0} />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
};

export default HiFive;
